import React from "react";
import { Box, Button, Typography } from "@material-ui/core";

export default function KnowledgePager({ page, count, loading, onChange, subject }) {
  return <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" mt={2} style={{ gap: 8 }}>
    <Typography variant="caption" color="textSecondary">{count ? `${(page - 1) * 20 + 1}–${Math.min(page * 20, count)}` : "0"} de {count} {subject}</Typography>
    <Box display="flex" style={{ gap: 8 }}>
      <Button size="small" aria-label={`Página anterior de ${subject}`} disabled={loading || page <= 1} onClick={() => onChange(page - 1)}>Anterior</Button>
      <Button size="small" aria-label={`Próxima página de ${subject}`} disabled={loading || page * 20 >= count} onClick={() => onChange(page + 1)}>Próxima</Button>
    </Box>
  </Box>;
}
